import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Toast configuration
const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Toast methods
const Toast = {
  success: (message) => {
    toast.success(
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {message}
      </div>,
      { ...toastConfig, className: 'custom-toast-success' }
    );
  },
  error: (message) => {
    toast.error(
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {message}
      </div>,
      { ...toastConfig, className: 'custom-toast-error' } 
    );
  },
};

// Toaster Component
const Toaster = () => {
  return (
    <ToastContainer />
  );
};

export { Toaster, Toast };
